import React, { useState } from 'react'
import GraphNetwork from '../../DebatesPsychometrics/GraphNetwork'
import PsychBigger from '../../../Psych/PsychBigger'
import { useSelector } from 'react-redux';


const DebateGraphs = ({psychData}) => {

  const loading = useSelector(state => state.debates.loading)
  const [clicked, setClicked] = useState(false)

  function viewBetter() {
    setClicked(!clicked)
  }


  return (
    <section className='w-full h-full'>
      <div className='my-4'>
        <p className='font-nunito text-base md:text-2xl italic text-center'>Graphs and Metrics</p>
      </div>


      {loading ?
        <div className='h-[300px] w-full flex flex-col items-center justify-center'>
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-[#3C6E71]"></div>
          <p className='my-3'>Loading Graph network</p>
        </div>
        :
        <div>
          {psychData?.nodes?.length > 0 ?
            (<div
              className='h-full w-full flex justify-center cursor-pointer'
              onClick={viewBetter}
              title='Tap to view enlarge graph'
            >
              <GraphNetwork
                data={psychData}
                fullscreen={clicked}
              />
            </div>)

            :
            <p className='text-center my-8'>No Metrics.</p>
          }
        </div>
      }





      {clicked &&
        <PsychBigger
          handleClosePopUp={viewBetter}
          child={
            <GraphNetwork
              newBg="#4b5563"
              data={psychData}
              fullscreen={clicked}
            />
          }
        />
      }
    </section>
  )
}

export default DebateGraphs